import axios from 'axios';

const widgetsAPI = {
  getWidgets() {
    return axios.get('/api/widgets');
  },

  getWidget(id) {
    return axios.get(`/api/widgets/${id}`);
  },

  createWidget(widget) {
    return axios.post('/api/widgets', widget);
  },

  updateWidget(id, widget) {
    return axios.put(`/api/widgets/${id}`, widget);
  },

  deleteWidget(id) {
    return axios.delete(`/api/widgets/${id}`);
  },

  getDashboardWidgets() {
    return axios.get('/api/dashboard/widgets');
  },

  pinWidget(dashboardWidget) {
    return axios.post('/api/dashboard/widgets', dashboardWidget);
  },

  updateDashboardWidget(id, dashboardWidget) {
    return axios.put(`/api/dashboard/widgets/${id}`, dashboardWidget);
  },

  unpinWidget(id) {
    return axios.delete(`/api/dashboard/widgets/${id}`);
  },
};

export default widgetsAPI;

